import './setup/class-component-hooks';
import Vue from 'vue';
import vuetify from './plugins/vuetify';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import shortkey from 'vue-shortkey';
import Vue2TouchEvents from 'vue2-touch-events';

Vue.config.productionTip = false;

Vue.use(shortkey);
Vue.use(Vue2TouchEvents, {
  tapTolerance: 10,           // default 10
  swipeTolerance: 50,         // default 30
  longTapTimeInterval: 750,   // default 400
});

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
  beforeCreate() {
    this.$store.commit('loadSettings');
  },
}).$mount('#app');
